import { render, staticRenderFns } from "./Load.vue?vue&type=template&id=13835c1a&"
import script from "./Load.vue?vue&type=script&lang=ts&"
export * from "./Load.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports